export const base_url = "https://api.kacha.net/v1/";

// https://staging.kacha.et/api/
// https://dev2.kachapay.net/api/
// https://api.kacha.net/v1/